import { render, staticRenderFns } from "./HappeningView.vue?vue&type=template&id=195252ac&scoped=true"
import script from "./HappeningView.vue?vue&type=script&lang=js"
export * from "./HappeningView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195252ac",
  null
  
)

export default component.exports